export function getPricingURL(instanceId) {
  return 'https://github.com/jarebear1923/Ayrow/issues'
}
